import { render, staticRenderFns } from "./ClaimPaymentList.vue?vue&type=template&id=5c427513&"
import script from "./ClaimPaymentList.vue?vue&type=script&lang=js&"
export * from "./ClaimPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports